export default __webpack_public_path__ + "static/media/line_package.245cced2.svg";